<template>
  <div></div>
</template>

<script>
  export default {
    props: {
      rowData: {
        type: Object,
        required: true,
      },
      rowIndex: {
        type: Number,
      },
    },
//    methods: {
//      onClick(event) {
//        console.log('my-detail-row: on-click', event.target);
//      },
//    },
  };
</script>



// WEBPACK FOOTER //
// src/components/app-table/detail-row.vue